// extracted by mini-css-extract-plugin
export default {"workOrderObjectsTotal":"WorkOrderVersionObjectTotals_workOrderObjectsTotal__DjrbD","workOrderObjectsTotalDetails":"WorkOrderVersionObjectTotals_workOrderObjectsTotalDetails__GnFwN"};